<template>
  <div class="container-fluid py-3 px-4">
      <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-lines-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            GESTION DE CESES
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE TRABAJADORES
          </p>
        </div>
      </div>
    </div>

   
    <div class="mt-2 pb-2">
      <div class="border border-1 rounded-3 p-3 mb-3  shadow-sm">

        <!-- 🔹 Título -->
        <div class="d-flex align-items-center mb-3">
          <i class="bi bi-funnel-fill fs-4 text-primary me-2"></i>
          <h4 class="fw-bold text-dark mb-0">FILTROS DE BÚSQUEDA: </h4>
        </div>

        <!-- 🔹 Campos de búsqueda -->
        <div class="row gy-3 gx-3">

          <!-- 🧍‍♂️ DOC IDENTIDAD -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person-vcard text-danger fs-5"></i> DOC. IDENTIDAD:
            </label>
            <b-input v-model.trim="Dni" placeholder="BUSQ. POR DOC. IDENTIDAD" @input="Dni = Dni.replace(/\s+/g, '');"
              @keydown.space.prevent></b-input>

          </div>

          <!-- 👤 APELLIDOS -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-person text-success fs-5"></i> APELLIDOS:
            </label>
            <b-input v-model.trim="Apellidos" placeholder="BUSQ. POR APELLIDOS"
              @input="Apellidos = Apellidos.replace(/^\s+/, '');"
              @keydown.space="Apellidos.length === 0 && $event.preventDefault()"></b-input>

          </div>

          <!-- 🏢 CLIENTE -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <label class="tamaño d-flex align-items-center gap-2">
              <i class="bi bi-diagram-3-fill text-info fs-5"></i> SUB SUBCENTRO:
            </label>
            <b-input v-model.trim="SubSubCentro" placeholder="BUSQ. POR SUB SUBCENTRO"
              @input="SubSubCentro = SubSubCentro.replace(/^\s+/, '');"
              @keydown.space="SubSubCentro.length === 0 && $event.preventDefault()"></b-input>

          </div>
        </div>
      </div>
    </div>

    <div class="border border-1 rounded-3 p-3 mb-2">

      <div class="d-flex justify-content-between mt-3 mx-2 gap-2 align-items-center">
        <!-- 🔹 Botón de Exportación LOCAL (Sin API) -->
        <button class="btn btn-success fw-bold shadow-sm d-flex align-items-center gap-2" 
                @click="exportarExcelLocal">
          <i class="bi bi-file-earmark-excel-fill fs-5"></i>
          EXPORTAR SELECCIONADOS
        </button>

        <div class="d-flex gap-2 align-items-center">
        <!-- 🔹 Botón de Acción Masiva -->
        <button v-if="seleccionadosMasivo.length > 0" 
                class="btn btn-success fw-bold shadow-sm d-flex align-items-center gap-2" 
                @click="registerSelected" 
                :disabled="isProcessingBatch">
          <i class="bi bi-check-all fs-5"></i>
          REGISTRAR SELECCIONADOS
        </button>

        <div
          class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm">
          <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
          <span class="fw-bold text-primary">
            Total de trabajadores: {{ GestionCese.length }}
          </span>
        </div>
      </div>
</div>

      <!-- 🔹 Tabla Única de Gestión de Ceses -->
      <div class="mt-3 mx-3 table-responsive">
        <table class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th colspan="1"></th>
                <th colspan="5">DATOS GENERALES</th>
                <th colspan="8">CESE</th>
              </tr>

              <tr class="bg-solimano text-white text-center text-nowrap   ">
                <th scope="col">
                  <!-- 🔹 Recuadro de Selección Masiva IDENTICO a RegRenIndividual -->
                  <div @click="MarcarTodos()"
                    :class="seleccionadosMasivo.length > 0 ? 'bg-dark border-white' : 'bg-white border-white'"
                    style="cursor: pointer; width: 12px; height: 12px; border: 1px solid; display: inline-block; border-radius: 2px; transition: 0.2s;">
                  </div>
                </th>
                <th scope="col">ESTADO</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">TRABAJADOR</th>
                <th scope="col">CONTRATO ACTUAL</th>
                <th scope="col">TAREO DIARIO</th>
                <th scope="col">BONIFICACIONES</th>
                <th scope="col">DESCUENTOS</th>
                <th scope="col">HORAS EXTRAS</th>
                <th scope="col">MOVILIDAD</th>
                <th scope="col">FECHA / MOTIVO</th>
                <th scope="col">DOC. ADJUNTO</th>
                <th scope="col">COMENTARIO</th>
                <th scope="col"><i class="bi bi-boxes"></i></th>
              </tr>
            </thead>
            <tbody class="align-middle">
              <tr class="text-center align-middle reducirTamaño" v-for="itema in paginatedGestionCese" :key="itema.id">


                <td class="text-center tabla-estiloCompreso" scope="row">
                  <div class="d-flex align-items-center justify-content-center">
                    <input class="checki" @change="actualizarEstado(itema)" type="checkbox" :value="itema.idCese"
                      v-model="itema.accionCese" />
                  </div>
                </td>

                <td class="text-start fw-bold align-middle" style="width: 150px;">
                  <div class="mb-1">{{ itema.periodo }}</div>


                  <span class="badge px-2 py-1" :class="{
                    'bg-primary': itema.cesCodEstado == 'EN PROCESO',
                    'bg-warning text-dark': itema.cesCodEstado == 'SOLICITADO',
                    'bg-danger': itema.renCodEstado == 'NO RENOVADO',
                  }">
                    {{ itema.cesCodEstado }}
                  </span>
                </td>



                <td class="text-start align-middle" style="width: 300px;">
                  <div class="fw-semibold text-primary">{{ itema.nomEmpresa }}</div>
                  <div class="text-muted small">{{ itema.subCentroCostos }}</div>
                  <div class="text-muted small">{{ itema.subSubCentroCostos }}</div>
                </td>

                <td class="text-start fw-bold align-middle" style="width: 300px;">
                  <div class="text-secondary">[ {{ itema.codTrabajador }} ]</div>
                  <div>{{ itema.nroDocumento }}</div>
                  <div class="text-primary">{{ itema.nomTrabajador }}</div>
                </td>


                <td class="text-center text-nowrap align-middle" style="width: 260px;">


                  <div class="fw-semibold text-primary mb-1">
                    {{ itema.nomPuesto }}
                  </div>


                  <div class="small">
                    <i class="bi bi-calendar-event text-primary"></i>
                    {{ new Date(itema.fechaIniContrato).toLocaleDateString('es-ES') }}
                    -
                    {{ new Date(itema.fechaFinContrato).toLocaleDateString('es-ES') }}
                  </div>


                  <div class="small mt-1">
                    <span class="fw-bold">Sueldo: </span>{{ itema.cesSueldo }}
                  </div>


                  <div class="small">
                    <span class="fw-bold">Asig. Familiar: </span>{{ itema.asignacionFamiliar }}
                  </div>
                </td>


                <td class="text-start fw-bold text-primary align-middle" style="width: 200px;">

                  <div class="d-flex justify-content-between small">
                    <span>Días Trab.:</span> <span>{{ itema.diasTrabajados }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Faltas:</span> <span>{{ itema.diasFaltas }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Desc. Médico:</span> <span>{{ itema.diasDescansoMedico }}</span>
                  </div>

                  <div class="border-top mt-1 pt-1 d-flex justify-content-between small fw-bold">
                    <span>Total:</span> <span>{{ itema.totalDias }}</span>
                  </div>
                </td>


                <td class="text-start fw-bold text-primary align-middle" style="width: 200px;">

                  <div class="d-flex justify-content-between small">
                    <span>Aguinaldo:</span> <span>{{ itema.aguinaldo }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Alimentos:</span> <span>{{ itema.alimentos }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>B. Nocturno:</span> <span>{{ itema.bonoNocturno }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>B. Regular:</span> <span>{{ itema.bonoRegular }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Comisión:</span> <span>{{ itema.comision }}</span>
                  </div>
                </td>

                <td class="text-center align-middle" style="width: 220px;">
                  <div class="d-flex flex-column gap-2">

                    <button class="btn btn-outline-primary boton-EstiloCuadrado reducirTamaño w-100" @click="$router.push(`/DescuentoTecnologiaParams/${itema.idTrabajador}/16`)">
                      BIENESTAR: {{ itema.desBienestar }}
                    </button>

                    <button class="btn btn-outline-warning boton-EstiloCuadrado reducirTamaño w-100" @click="$router.push(`/DescuentoTecnologiaParams/${itema.idTrabajador}/7`)">
                      CONTABILIDAD: {{ itema.desContabiliad }}
                    </button>

                    <button class="btn btn-outline-danger boton-EstiloCuadrado reducirTamaño w-100" @click="$router.push(`/DescuentoTecnologiaParams/${itema.idTrabajador}/5`)">
                      TECNOLOGÍA: {{ itema.desTecnologia }}
                    </button>
<!-- /${itema.idTrabajador} -->
                  </div>
                </td>


                <!-- HORAS EXTRA -->
                <td class="text-start fw-bold text-primary align-middle" style="width: 180px;">

                  <div class="d-flex justify-content-between small">
                    <span>Hr.Ext. 25%:</span>
                    <span>{{ itema.horaExtra25 }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Hr.Ext. 35%:</span>
                    <span>{{ itema.horaExtra35 }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Hr.Ext. 50%:</span>
                    <span>{{ itema.horaExtra50 }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Hr.Ext. 100%:</span>
                    <span>{{ itema.horaExtra100 }}</span>
                  </div>

                </td>


                <td class="text-start fw-bold text-primary align-middle" style="width: 160px;">

                  <div class="d-flex justify-content-between small">
                    <span>Mov. 100%:</span>
                    <span>{{ itema.movilidad }}</span>
                  </div>

                  <div class="d-flex justify-content-between small">
                    <span>Mov. Extra:</span>
                    <span>{{ itema.movilidadExtra }}</span>
                  </div>
                </td>

                <td class="text-center align-middle" style="width: 160px;">
                  <div class="small fw-bold">
                    {{ new Date(itema.fechaCese).toLocaleDateString('es-ES') }}
                  </div>

                  <div class="small text-secondary mt-1">
                    <span v-if="itema.motivoCese.length > 0">
                      {{ itema.motivoCese }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </td>


                <td class="align-middle small" style="width: 140px;">
                  {{ itema.cesEstadoAdjunto ? 'ADJUNTO CARGADO' : 'SIN ADJUNTO' }}
                  <a :href="itema.cesAdjunto" v-if="itema.cesEstadoAdjunto" class="btn btn-danger" target="_blank" rel="noopener">
                    <i class="bi bi-file-earmark-pdf text-white fs-7"></i>
                  </a>
                </td>


                <td class="align-middle sm*-all" style="width: 200px;">
                  {{ itema.comentario }}
                </td>


                <td class="py-0 my-0 align-middle text-center " style="width: 80px;">
                  <button :disabled="!itema.accionCese" @click="Registro(itema)" class="btn btn-outline-success btn-sm px-3 py-1">
                    <i class="bi bi-check-circle-fill"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

        <!-- 🔹 Paginación -->
        <div v-if="totalPages > 1" class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
          <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>
          <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i>
          </button>
          <span class="pagination-info fw-semibold">Página {{ currentPage }} de {{ totalPages }}</span>
          <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-right"></i>
          </button>
          <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages" :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: 'SolimanologGestionDeCese',

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Renovacion/",
      checkeId: [],
      pdfMasivo: [],
      perPage: 10,
      currentPage: 1,
      pdfIndividual: [],
      texto: "",
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      currentTab: 'tab1',

      from: {
        idCese: "",
      },

      motivo: [],
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      puesto: [],
      dniUsuario: "",
      idEmpresa: "",
      cenCodigoCentro: "",
      cenCodigoSubCentro: "",
      cenCodigoSubSubCemtro: "",
      codRenMotivo: "",
      fechaIni: "1900-01-01T00:00:00.000Z",
      fechaFin: "1900-01-01T00:00:00.000Z",
      idPuesto: "0",
      sueldo: 0,
      sueldoFinal: 0,
      isdisabled: false,
      isdisabled2: false,
      isProcessingBatch: false,

      CentroDeCostoMasivo: [],
      SubCentroDeCostoMasivo: [],
      idEmpresaMasivo: [],
      SubSubCentroDeCostoMasivo: [],
      cenCodigoCentroMasivo: "",
      cenCodigoSubCentroMasivo: "",
      cenCodigoSubSubCemtroMasivo: "",
      idPuestoMasivo: "",
      sueldoMasivo: "",
      fechaIniMasivo: "",
      fechaFinMasivo: "",
      colorRenovacion: "",
      fechaContraRestar: "",
      pdf: null,
      pdfMasivos: null,

      idTrabajador: "",
      pdfVariable: true,

      documentos: [],
      totalSSCC: [],
      idTrabajadorUnico: "",

      fileInputKey: 0,

    };
  },

  mounted() {
    // const fecha = new Date();
    // this.fechaContraRestar = fecha.toISOString().slice(0, 10);
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");

    this.axios.get("ParametroData/Parametro/7683").then((r) => {
      this.motivo = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      this.puesto = r.data; //ss
    });

    // console.log(this.letra.length)
  },

  created() {
    this.GestionCeses();
    this.getAttributes();
    // this.convertBase64ToImage();
  },
  computed: {
    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("renovaciones", ["GestionCese"]),

    filteredGestionCese() {
      let data = this.GestionCese;

      if (this.Dni) {
        data = data.filter(item =>
          item.nroDocumento?.toString().includes(this.Dni)
        );
      }

      if (this.Apellidos) {
        const texto = this.Apellidos.toLowerCase();
        data = data.filter(item =>
          item.nomTrabajador?.toLowerCase().includes(texto)
        );
      }

      if (this.SubSubCentro) {
        const texto = this.SubSubCentro.toLowerCase();
        data = data.filter(item =>
          item.subSubCentroCostos?.toLowerCase().includes(texto)
        );
      }

      return data;
    },

    paginatedGestionCese() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredGestionCese.slice(start, start + this.perPage);
    },

    totalPages() {
      return Math.ceil(this.filteredGestionCese.length / this.perPage);
    },

    seleccionadosMasivo() {
      // Filtra los items que tienen renAccionReg en true (seleccionados)
      return this.GestionCese.filter(item => item.accionCese);
    }
  },

  watch: {
    Dni() {
      this.currentPage = 1;
    },
    Apellidos() {
      this.currentPage = 1;
    },
    SubSubCentro() {
      this.currentPage = 1;
    }
  },


  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("renovaciones", ["GestionCeses"]),

    MarcarTodos() {
      // 1. Verificamos si todos los filtrados ya están marcados (Igual que RegRenIndividual)
      const todosMarcados = this.filteredGestionCese.every(item => item.accionCese == true);

      // 2. Definimos acción
      const nuevaAccion = todosMarcados ? "0" : "1";

      // 3. Obtenemos los IDs de la búsqueda actual
      const ids = this.filteredGestionCese.map(item => item.idCese).join(',');

      if (!ids) return;

      // Mostramos spinner de carga idéntico al solicitado
      Swal.fire({
        title: 'Procesando',
        text: 'Por favor espere mientras se actualiza la selección...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const data = {
        idCeses: ids,
        accion: nuevaAccion
      };
      console.log(data)

      // Llamada al endpoint masivo de Ceses
      this.axios.put("Cese/CambioEstadoGeneralxCese", data)
        .then(res => {
          if (res.data) {
            // 4. Actualizamos la vista localmente para que los checks cambien
            this.filteredGestionCese.forEach(item => {
              item.accionCese = (nuevaAccion === "1");
            });
            
            Swal.fire({
              title: nuevaAccion === "1" ? '¡Seleccionado!' : '¡Desmarcado!',
              text: nuevaAccion === "1" ? 'Se han seleccionado todos los registros.' : 'Se han desmarcado todos los registros.',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
          }
        })
        .catch(err => {
          console.error(err);
          Swal.fire('Error', 'Ocurrió un problema al procesar la solicitud.', 'error');
        });
    },

    async registerSelected() {
      if (this.seleccionadosMasivo.length === 0) {
        await Swal.fire("Advertencia", "No hay trabajadores seleccionados.", "warning");
        return;
      }

      const result = await Swal.fire({
        title: '¿Registrar seleccionados?',
        text: `Se procesarán ${this.seleccionadosMasivo.length} ceses.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, registrar todos'
      });

      if (!result.isConfirmed) return;

      this.isProcessingBatch = true;
      for (const item of this.seleccionadosMasivo) {
        await this.Registro(item); // Llama al método de registro individual para cada elemento seleccionado
      }
      this.isProcessingBatch = false;
      await Swal.fire("Éxito", "Registro masivo completado.", "success");
    },

    exportarExcelLocal() {
      if (this.seleccionadosMasivo.length === 0) {
        Swal.fire("Atención", "Debe seleccionar al menos un registro (usando el checkbox) para exportar.", "warning");
        return;
      }

      // 🔹 Mostrar modal de carga de SweetAlert2
      Swal.fire({
        title: 'Generando Excel',
        text: 'Por favor espere mientras se prepara el archivo...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // 🔹 Usamos un pequeño delay para que el Swal se muestre antes del proceso pesado
      setTimeout(() => {
      // 1. Definir las cabeceras del archivo
      const headers = [
        "PERIODO", "ESTADO", "EMPRESA", "SUB CENTRO", "SUB SUB CENTRO", 
        "COD. TRAB", "DNI", "TRABAJADOR", "PUESTO", "FECHA INICIO", "FECHA FIN", 
        "SUELDO", "DIAS TRAB", "FALTAS", "DESC. MEDICO", "VACACIONES", "TOTAL DIAS", 
        "FECHA CESE", "MOTIVO", "COMENTARIO"
      ];

      // 2. Mapear los datos filtrados a filas
      const rows = this.seleccionadosMasivo.map(item => [
        item.periodo,
        item.cesCodEstado,
        item.nomEmpresa,
        item.subCentroCostos,
        item.subSubCentroCostos,
        item.codTrabajador,
        item.nroDocumento,
        item.nomTrabajador,
        item.nomPuesto,
        item.fechaIniContrato?.slice(0, 10),
        item.fechaFinContrato?.slice(0, 10),
        item.cesSueldo || 0,
        item.diasTrabajados || 0,
        item.diasFaltas || 0,
        item.diasDescansoMedico || 0,
        item.diasVacaciones || 0,
        item.totalDias || 0,
        item.fechaCese?.slice(0, 10),
        item.motivoCese,
        item.comentario || ""
      ]);

      // 3. Generar el contenido en formato XML/HTML para soportar estilos y filtros
      let htmlContent = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="utf-8">
          <!--[if gte mso 9]>
          <xml>
            <x:ExcelWorkbook>
              <x:ExcelWorksheets>
                <x:ExcelWorksheet>
                  <x:Name>Listado de Ceses</x:Name>
                  <x:WorksheetOptions>
                    <x:DisplayGridlines/>
                    <x:AutoFilter x:Range="R1C1:R1C20"/>
                  </x:WorksheetOptions>
                </x:ExcelWorksheet>
              </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
          <![endif]-->
          <style>
            .header { background-color: #1565C0; color: #ffffff; font-weight: bold; border: 0.5pt solid #000000; text-align: center; }
            .cell { border: 0.5pt solid #cccccc; }
            .text-cell { mso-number-format:"\\@"; } /* Evita que el DNI pierda ceros a la izquierda */
          </style>
        </head>
        <body>
          <table>
            <thead>
              <tr>
                ${headers.map(h => `<th class="header">${h}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${rows.map(row => `
                <tr>
                  ${row.map(cell => `<td class="cell text-cell">${(cell === 0 || cell) ? cell : ''}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
        </html>`;

      // 4. Crear el link de descarga con extensión .xls
      const blob = new Blob([htmlContent], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `Gestion_Ceses_${new Date().toISOString().slice(0,10)}.xls`);
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);

      Swal.close(); // Cerramos el modal al terminar
      }, 500);
    },


    // fetchItems() {
    //   console.log(this.Dni.length);

    //   if (this.Dni.length == 0) {
    //     this.primeraTabla = true;
    //     this.segundaTabla = false;
    //     this.terceraTabla = false;
    //     this.GestionCeses();
    //   } else {
    //     this.axios
    //       .get(
    //         `Renovacion/BusquedaxDni?NroDocumento=${this.Dni}&idTrabajador=${this.idTrabajador}&codEstado=002`
    //       )
    //       .then((response) => {
    //         console.log(response);

    //         if (response.status == 200) {
    //           this.primeraTabla = false;
    //           this.segundaTabla = true;
    //           this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
    //         }
    //         //this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
    // },

    // fetchApellido() {
    //   if (this.Apellidos.length == 0) {
    //     this.primeraTabla = true;
    //     this.segundaTabla = false;
    //     this.terceraTabla = false;
    //     this.GestionCeses();
    //   } else {
    //     this.axios
    //       .get(
    //         `Renovacion/BusquedaxApellido?Apellido=${this.Apellidos}&idTrabajador=${this.idTrabajador}&codEstado=002`
    //       )
    //       .then((response) => {
    //         console.log(response);

    //         if (response.status) {
    //           this.primeraTabla = false;
    //           this.segundaTabla = true;
    //           this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
    //         }
    //         this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
    // },

    // fetchSubSubCentro() {
    //   this.documentos = [];
    //   if (this.SubSubCentro.length == 0) {
    //     this.primeraTabla = true;
    //     this.segundaTabla = false;
    //     this.terceraTabla = false;
    //     this.GestionCeses();
    //   } else {
    //     this.axios
    //       .get(
    //         `Renovacion/BusquedaxSubSubCc?cuenta=${this.SubSubCentro}&idTrabajador=${this.idTrabajador}&codEstado=002`
    //       )
    //       .then((response) => {
    //         console.log(response.status);

    //         if (response.status) {
    //           this.primeraTabla = false;
    //           this.segundaTabla = false;
    //           this.terceraTabla = true;
    //           this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
    //           console.log(response.data);
    //         }
    //         this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
    // },

   
    

    cambiarEstadoPdf(id) {
      this.axios.put(`Renovacion/EstadoPdf?idRenovacion=${id}`).then((r) => {
        console.log(r.data);
        Swal.fire(`Cambio de estado realizado`, "", "success");
        this.GestionCeses();
      });
    },

    mandarPdfServicios(id, trabajador) {
      this.idRenovacion = id;
      this.idTrabajador = trabajador;
    },

    handleFileUpload(event) {
      let file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        console.log(file);

        let formData = new FormData();
        formData.append("Archivo", file);
        formData.append("idRenovacion", this.idRenovacion);
        this.fileInputKey += 1;

        this.axios
          .put("Renovacion/AdjuntoRen", formData)
          .then((response) => {
            console.log(response.data);
            if (response.data == true) {
              Swal.fire("Guardado", "", "success");

              for (let index of this.GestionCese) {
                if (
                  index.idPuesto === index.idPuestoNuevo &&
                  this.idTrabajador === index.idTrabajador &&
                  index.renSueldoActual == index.renSueldo
                ) {
                  console.log("SE APLICO INSERTAR IMAGEPDF");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenPdf?idRenovacion=${this.idRenovacion}`
                    )
                    .then((r) => {
                      console.log(r);
                      if (r.data == true) {
                        this.axios
                          .put(
                            `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                          )
                          .then((r) => {
                            console.log(r.data);
                            if (r.data == true) {
                              this.GestionCeses();
                              this.idTrabajador = "";
                              this.idRenovacion = "";
                            }
                          });
                      }
                    });
                }

                if (
                  this.idTrabajador === index.idTrabajador &&
                  index.renSueldoActual != index.renSueldo &&
                  index.idPuesto === index.idPuestoNuevo
                ) {
                  console.log("SE APLICO INSERTAR ADEDA");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenAdenda?idRenovacion=${this.idRenovacion}`
                    )
                    .then((r) => {
                      if (r.data == true) {
                        this.axios
                          .put(
                            `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                          )
                          .then((r) => {
                            console.log(r.data);
                            if (r.data == true) {
                              this.GestionCeses();
                              this.idTrabajador = "";
                              this.idRenovacion = "";
                            }
                          });
                      }
                    });
                }

                if (
                  index.idPuesto != index.idPuestoNuevo &&
                  index.renSueldoActual == index.renSueldo &&
                  this.idTrabajador == index.idTrabajador
                ) {
                  console.log("SE APLICA INSERTADR ADENDA 2");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenAdenda?idRenovacion=${this.idRenovacion}`
                    )
                    .then((r) => {
                      if (r.data == true) {
                        this.axios
                          .put(
                            `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                          )
                          .then((r) => {
                            console.log(r.data);
                            if (r.data == true) {
                              this.GestionCeses();
                              this.idTrabajador = "";
                              this.idRenovacion = "";
                            }
                          });
                      }
                    });
                }

                if (
                  index.idPuesto != index.idPuestoNuevo &&
                  index.renSueldoActual !== index.renSueldo &&
                  this.idTrabajador == index.idTrabajador
                ) {
                  console.log("SE APLICA INSERTADR ADENDA 2");
                  this.axios
                    .get(
                      `Renovacion/InsertarImagenAdenda?idRenovacion=${this.idRenovacion}`
                    )
                    .then((r) => {
                      if (r.data == true) {
                        this.axios
                          .put(
                            `Renovacion/EstadoAdjunto?idRenovacion=${this.idRenovacion}`
                          )
                          .then((r) => {
                            console.log(r.data);
                            if (r.data == true) {
                              this.GestionCeses();
                              this.idTrabajador = "";
                              this.idRenovacion = "";
                            }
                          });
                      }
                    });
                }
              }
            }

            // Realizar acciones adicionales según sea necesario
          })
          .catch((error) => {
            console.error(error);
            // Manejar el error de alguna manera
          });
      } else {
        // Archivo inválido, muestra un mensaje de error o realiza acciones adicionales
        console.error("Seleccione un archivo PDF válido");
      }
      // Aquí puedes realizar las acciones necesarias con el archivo subido, como enviarlo al servidor o procesarlo.
    },

    Firma(items) {
      // this.firmasDigital = true
      this.idTrabajador = items.idTrabajador;

      this.$router.push("/firmas/" + items.idTrabajador);
    },

    cambiarEstadoRen(items) {
      console.log(items.idTrabajador);
      this.axios
        .put(
          `Renovacion/EstadoNoRenovado?idRenovacion=${items.idRenovacion}
`
        )
        .then((r) => {
          if (r.data) {
            Swal.fire(`Cambio de estado realizado`, "", "success");
          }
          this.GestionCeses();
        });
    },

    Registro(items) {
      this.axios
        .put(`Cese/EstadoTerminadoCambio?idCese=${items.idCese}`)
        .then(async (r) => {
          if (r.data === true) {
            Swal.fire("Registro Realizado", "", "success");
          } else {
            Swal.fire("Error", "No se pudo registrar.", "error");
          }
        })
        .catch(async (error) => {
          console.error(error);
          Swal.fire("Error", "Error al procesar el registro.", "error");
        })
        .finally(() => {
          this.GestionCeses();
        });
    },

    Rechazo(idRenovacion, item) {
      console.log(idRenovacion);

      Swal.fire({
        // title: 'Desea Rechazar?',
        text: "¿Desea Rechazar la renovación seleccionada?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Si",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .put(`Renovacion/ModificarEstadoxRen`, { idRenovacion })
            .then((r) => {
              console.log(r.data);
              if (r.data) {
                this.GestionCeses();
                this.axios
                  .post(
                    `Renovacion/CorreoRechazo?correoUsuario=gvicente@gruposolimano.com.pe&Nombre=${item.nomTrabajador}&Motivo=${this.texto}`
                  )
                  .then((r) => {
                    console.log(r.data);
                  });
              }
            });
          Swal.fire("Rechazado!", "", "success");
        }
      });
    },

    DescargarPdf(items) {
      for (let index of this.GestionCese) {
        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual == index.renSueldo
        ) {
          console.log("hola1");
          this.axios
            .get(
              `/Renovacion/GenerarPdf?nomEmpresa=${items.nomLargoEmp}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log(r);
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }

        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo
        ) {
          console.log("se cambio el sueldo");

          this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${items.nomLargoEmp}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log("hola mundo");
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }

        if (
          items.idPuesto != index.idPuestoNuevo &&
          items.idTrabajador == index.idTrabajador &&
          index.renSueldoActual == index.renSueldo
        ) {
          console.log("se cambio el puesto");
          this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${items.nomLargoEmp}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log("hola mundo");
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }

        if (
          items.idPuesto !== index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo
        ) {
          console.log("see cambiaron los dos");
          this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${items.nomLargoEmp}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.nomFechaIniContrato}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaIniContratos}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}`,
              { responseType: "blob" }
            )
            .then((r) => {
              this.pdf = r.data;
              console.log("hola mundo");
              if (r.status == 200) {
                this.GenerarPdf();
              }
            });
        }
      }
    },

    GenerarPdf() {
      var fileURL = window.URL.createObjectURL(new Blob([this.pdf]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Contrato.pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
      window.URL.revokeObjectURL(fileURL);
    },

    
 

    Indi() {
      this.individual = true;
      this.masivo = false;
      this.GestionCeses();
      this.isdisabled2 = false;
    },

    Masi() {
      (this.individual = false), (this.masivo = true);
      this.GestionCeses();
      this.checkeId = [];
    },

    Motivos(event) {
      this.codRenMotivo = event.target.value;
    },

    Motivo(event) {
      this.texto = event.target.value;
      console.log(event.target.value);
    },

    SubSubCentroCostos(event) {
      this.cenCodigoSubCentro = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${this.cenCodigoCentro}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroCosto = r.data;
          console.log(r.data);
        });
    },
    // annes

    SubSubCentroCostosManda(event) {
      this.cenCodigoSubSubCemtro = event.target.value;
      console.log(event.target.value);
    },

    Puesto(event) {
      this.idPuesto = event.target.value;
    },

    mostrar(event) {
      this.sueldo = event.target.value;
      console.log(event.target.value);
    },

    FechaIni(event) {
      this.fechaIni = event.target.value;
      console.log(event.target.value);
    },

    FechaFin(event) {
      this.fechaFin = event.target.value;
    },

    actualizarEstado(items) {
      console.log(items);
      this.from.idCese = items.idCese;

      // Lógica de búsqueda de centros de costo al marcar (igual que en RegRenIndividual)
      for (let index of this.GestionCese) {
        if (index.idCese == items.idCese) {
          this.axios
            .get(
              `SubSubCentro/SScxTrabajador?idEmpresa=${index.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${index.cesCodCC}&codSubCentro=${index.cesCodScc}`
            )
            .then((r) => {
              this.SubSubCentroCosto = r.data;
              console.log(r.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (items.accionCese == true) {
        this.isdisabled2 = true;
        this.colorRenovacion = items.idCese;
      } else {
        this.colorRenovacion = "";
      }

      this.axios.put("Cese/ModificarAccionxCese", { idCese: items.idCese }).then((r) => {
        console.log(r);
      });
    },

    CentroCostoMasivo(event) {
      this.idEmpresaMasivo = event.target.value;
      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniUsuario}`
        )
        .then((r) => {
          this.CentroDeCostoMasivo = r.data;
          console.log(r.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    SubCentroCostoMasivo(event) {
      this.cenCodigoCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${event.target.value}&dniUser=${this.dniUsuario}&idEmpresa=${this.idEmpresaMasivo}`
        )
        .then((r) => {
          this.SubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroDeCostosMasivo(event) {
      this.cenCodigoSubCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresaMasivo}&dniUser=${this.dniUsuario}&codCentro=${this.cenCodigoCentroMasivo}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroCostosMandaMasivo(event) {
      this.cenCodigoSubSubCemtroMasivo = event.target.value;
      console.log(event.target.value);
    },

    PuestoMasivo(event) {
      this.idPuestoMasivo = event.target.value;
      console.log(event.target.value);
    },

   
  },
};
</script>

<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.small-Bar-container,
.line-chart-container,
.stacked-bar-container {
  width: 100%;
  max-width: 250px;
  /* tamaño mediano */
  min-height: 200px;
  /* altura mediana */
  background: white;
  border-radius: 8px;
  padding: 15px;
  margin: 20px auto;
  /* centra horizontalmente en la página */
  display: flex;
  justify-content: center;
  /* centra el gráfico horizontal */
  align-items: center;
  /* centra el gráfico vertical */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-xl-custom {
  max-width: 90%;
}

.modal-ancho-personalizado {
  max-width: 80vw;
  width: 100%;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.cursor-pointer {
  cursor: pointer;
}
</style>